import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierHeaderTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierHeaderTranslations',
	title: 'Header Section Translations',
	sanityId: 'buyeasy-supplierHeader',
	fields: {
		headerSectionTitle: 'SUPPLIER HEADER',
		supplierId: 'Supplier ID',
		anid: 'ANID',
		globalParent: 'Global Parent',
		industryKey: 'Industry key',
		preferred: 'Preferred',
		preferredInProgress: 'Preferred in progress',
		preferredTPRMInProgress: 'Preferred - TPRM in Progress',
		diverse: 'Diverse',
		sbti: 'SBTI',
		ers: 'ERS',
		subcontractor: 'Subcontractor',
		available: 'Available for You',
		freelancer: 'Freelancer',
		notAvailable: 'Not available for You',
		availabilityTooltip:
			'Available to You means the Supplier is setup in your selected Company Code & P-Org.  Otherwise, the Supplier is Not Available to You.',
		chooseTheRightBuyingChannel: 'Choose the right Buying Channel',
		howToBuyAndTprmCheck: 'How to Buy/Check TPRM',
		buyFromCatalog: 'Buy from Catalog',
		buyOnBehalfButton: 'Buy On Behalf Of',
		viewCatalogButton: 'Buy for myself',
		purchaseCheckTprm: 'Purchase / Check tprm',
		catalog: 'Catalog',
		buyingForSomeoneElse: 'Buying for someone else?',
	},
});
